<template>
  <div class="plan-list-page">
    <section class="search-container">
      <div class="select-field-row">
        <div class="selectFieldBox" @click="showNum += 1">
          <span class="select-field-label ellipsis" :class="{ black: hasDealer }">{{ dealer.name }}</span>
          <div class="select-field-icon">
            <van-icon name="arrow-down" />
          </div>
        </div>
      </div>
      <div class="select-field-row">
        <div class="selectFieldBox selectFieldType " @click="showClass += 1">
          <span class="select-field-label ellipsis" :class="{ black: hasClass }">{{ carClass }}</span>
          <div class="select-field-icon">
            <van-icon name="arrow-down" />
          </div>
        </div>
        <div class="selectFieldBox selectFieldYear" @click="showYear = true">
          <span class="select-field-label" :class="{ black: hasCarAge }">{{ carAge }}</span>
          <div class="select-field-icon">
            <van-icon name="arrow-down" />
          </div>
        </div>
      </div>
      <div v-if="planList.length">
        <Divider text="以下是适合您的致友计划" size="12" imgWidth="20%" />
        <LoyaltyCard v-if="planList.length" :planList="planList" />
        <Divider text="已加载全部" size="12" imgWidth="20%" />
      </div>
      <div v-if="planList.length == 0" class="select-describe">
        <span v-if="!hasClass || !hasDealer">选择经销商和车型查找适合的致友计划</span>
        <span v-if="noData">抱歉，没有找到符合条件的致友计划</span>
      </div>
    </section>
    <div v-show="isShowLoad" class="loadBox">
      <van-loading size="30px" vertical color="#fff"><span style="color:#fff">加载中...</span> </van-loading>
    </div>
    <SwitchDealer :showNum="showNum" @dealerFn="dealerFn" />
    <SelectCar :showPopUp="showClass" @selectCarResult="selectCarResult" from="plan" />
    <van-popup v-model:show="showYear" round position="bottom" safe-area-inset-bottom>
      <van-picker title="车龄" :visible-item-count="7" :columns="yearList" @confirm="confirmCarAge" @cancel="showYear = false" />
    </van-popup>
  </div>
</template>

<script>
import { reactive, toRefs, watch, onMounted } from 'vue'
import SwitchDealer from '@/components/dealer/SwitchDealer'
import LoyaltyCard from '@/components/plan/LoyaltyCard'
import Divider from '@/components/common/Divider'
import SelectCar from '@/components/common/SelectCar'
import { getCarAge, getPlanList } from '@/api/plan'
import { getMyDefault } from '@/api/car'
import { setSession, getSession } from '@/util'
import { getDefaultDealer } from '@/api/tyre'
import { useStore } from 'vuex'
export default {
  name: 'planList',
  components: {
    LoyaltyCard,
    Divider,
    SwitchDealer,
    SelectCar
  },
  setup() {
    const store = useStore()
    let { loyaltyDealerInfo: dealerInfo, currentCarClassInfo } = store.state
    let carAge = getSession('carAge')
    const state = reactive({
      dealer: dealerInfo && dealerInfo.name ? dealerInfo : { name: '请选择经销商(必选)' },
      hasDealer: !!dealerInfo?.id,
      showNum: 1,
      hasClass: !!currentCarClassInfo.text,
      hasCarAge: !!carAge && !(carAge === '全部'),
      showClass: 0,
      showYear: false,
      carClass: currentCarClassInfo.text || '请选择车系车型(必选)',
      carAge: carAge || '全部',
      yearList: [],
      provinceCityColumnsList: [],
      provinceCityList: [],
      baumuster: currentCarClassInfo.baumuster || '',
      planList: getSession('planList') || [],
      noData: false,
      isShowLoad: false
    })
    const getDefaultDealerFn = async () => {
      if (!dealerInfo.gs_code) {
        let position = store.state?.position || {}
        let { lat: latitude = '', lng: longitude = '' } = position
        let param = { productType: 1, latitude, longitude }
        let data = await getDefaultDealer(param)
        let _gsCode = dealerInfo.gs_code || dealerInfo.gsCode
        data.gs_code = data.gsCode = _gsCode
        state.dealer = data
        state.hasDealer = !!data.gsCode
        store.dispatch('setLoyaltyDealerInfo', state.dealer)
      } else {
        state.dealer = dealerInfo || { name: '请选择经销商(必选)' }
        state.hasDealer = !!dealerInfo.gs_code
      }
    }

    watch([() => state.dealer, () => state.baumuster, () => state.carAge], async ([dealer, baumuster, carAge]) => {
      if (!(state.hasDealer && state.hasClass)) return
      state.isShowLoad = true
      state.noData = false
      let pramas = {
        gsCode: state.hasDealer ? dealer.gs_code : '',
        baumuster: state.hasClass ? baumuster : '',
        carAge: state.hasCarAge ? carAge : '',
        pageNo: '1',
        pageSize: '10000'
      }
      let { list = [] } = await getPlanList(pramas)
      state.isShowLoad = false
      state.noData = list.length === 0
      state.planList = list
      setSession('planList', list)
    })
    const selectCarResult = val => {
      state.hasClass = true
      state.carClass = val.text
      state.baumuster = val.baumuster
    }
    // 设置车型参数
    const setCarClassByDefaultCar = async () => {
      let defaultCar = await getDefaultCar()
      let sessionCarAge = getSession('carAge') || ''
      let defaultCarAge = defaultCar.carAge === 0 ? '新车' : !defaultCar.carAge ? '全部' : defaultCar.carAge > 10 ? '10年以上' : `${defaultCar.carAge}年`
      let carAge = sessionCarAge ? sessionCarAge : defaultCarAge
      confirmCarAge(carAge)
      state.hasClass = !!defaultCar.text
      state.carClass = defaultCar.text || '请选择车系车型(必选)'
      state.baumuster = defaultCar.baumuster || ''
    }
    // 获取默认车型
    const getDefaultCar = async () => {
      let defaultCar = {}
      let { currentCarClassInfo } = store.state
      if (currentCarClassInfo) {
        return currentCarClassInfo
      }
      try {
        defaultCar = await getMyDefault()
      } catch (e) {
        let myCarListArr = store.state.myCarList || []
        let defaultCarArr = myCarListArr.filter(({ defaultFlag }) => defaultFlag)
        defaultCar = defaultCarArr[0] ? defaultCarArr[0] : {}
      }
      if (defaultCar && defaultCar.baumuster) {
        defaultCar = {
          ...defaultCar,
          text: defaultCar.model
        }
        store.dispatch('setCurrentCarClassInfo', defaultCar)
      } else {
        defaultCar = {}
      }
      return defaultCar
    }

    const dealerFn = val => {
      state.dealer = val
      state.hasDealer = true
    }
    const confirmCarAge = val => {
      state.showYear = false
      state.hasCarAge = !(val === '全部')
      state.carAge = val
      setSession('carAge', val)
    }
    onMounted(async () => {
      let yearList = getSession('yearList')
      if (!yearList) {
        yearList = await getCarAge()
        yearList.push('全部')
        setSession('yearList', yearList)
      }
      state.yearList = yearList
      // 设置车型相关参数
      setCarClassByDefaultCar()
      getDefaultDealerFn()
    })
    return {
      ...toRefs(state),
      selectCarResult,
      confirmCarAge,
      dealerFn
    }
  }
}
</script>

<style lang="scss" scoped>
.plan-list-page {
  background-color: #f5f5f5;
  .search-container {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: calc(60px + constant(safe-area-inset-bottom));
    padding-bottom: calc(60px + env(safe-area-inset-bottom));
    color: #999;
    font-size: 14px;
    .select-field-row {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      .selectFieldBox {
        display: flex;
        width: 100%;
        height: 40px;
        border: 1px solid #eee;
        background-color: #fff;
        .select-field-label {
          display: inline-block;
          width: calc(100% - 30px);
          height: 100%;
          line-height: 40px;
          padding-left: 12px;
          text-align: left;
        }
        .black {
          color: #000;
        }
        .select-field-icon {
          width: 30px;
          align-items: center;
          .van-icon {
            height: 100%;
            margin-top: 50%;
          }
        }
      }
      .selectFieldType {
        width: 180px;
      }
      .selectFieldYear {
        width: 145px;
      }
    }
    .select-describe {
      padding-top: 20px;
    }
  }
}
.loadBox {
  position: fixed;
  left: 0;
  top: 0px;
  width: 100%;
  height: 100%;
  padding-top: 250px;
  background-color: rgba($color: #000000, $alpha: 0.4);
}
</style>
